import script from "./login.vue?vue&type=script&setup=true&lang=ts"
export * from "./login.vue?vue&type=script&setup=true&lang=ts"

import "./login.vue?vue&type=style&index=0&id=197f222f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-197f222f"]])

export default __exports__